export default __webpack_public_path__ + "static/media/img-about-2-new-min.40432152.png";